import { Link } from 'react-router-dom'
import { getAllArticles, getFeaturedArticles } from '../data/articles'
import './HomePage.css'

function HomePage() {
  const articles = getAllArticles()
  const featured = getFeaturedArticles()

  const formatDate = (dateStr) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    return new Date(dateStr).toLocaleDateString('en-US', options)
  }

  const ArticleCard = ({ article }) => (
    <div className="article-card">
      <Link to={`/article/${article.slug}`} className="article-card-image">
        {article.image && <img src={article.image} alt={article.title} />}
      </Link>
      <div className="article-card-content">
        <h3>
          <Link to={`/article/${article.slug}`} className="article-card-title">
            {article.title}
          </Link>
        </h3>
        <div className="article-card-meta">
          <time dateTime={article.date}>{formatDate(article.date)}</time>
        </div>
      </div>
    </div>
  )

  return (
    <div className="home-page">
      {featured.length > 0 && (
        <section className="featured-section">
          <h2>Featured Articles</h2>
          <div className="articles-grid featured-grid">
            {featured.map(a => (
              <ArticleCard key={a.slug} article={a} />
            ))}
          </div>
        </section>
      )}

      <section className="all-articles-section">
        <h2>All Articles</h2>
        <div className="articles-grid">
          {articles.map(a => (
            <ArticleCard key={a.slug} article={a} />
          ))}
        </div>
      </section>
    </div>
  )
}

export default HomePage
